import React from 'react';
import { motion } from 'framer-motion';
import { Wrench, Zap, Package, Infinity } from 'lucide-react';
const principles = [{
  icon: Wrench,
  title: 'Działa w praktyce — nie na papierze',
  description: 'Każda strona to narzędzie gotowe do użycia na Twoim treningu dzisiaj. Nie podręcznik akademicki.'
}, {
  icon: Zap,
  title: 'Zacznij używać od razu',
  description: 'Bez uczenia się oprogramowania. Bez szkoleń. Otwórz PDF i zacznij trenować.'
}, {
  icon: Package,
  title: 'Kompletny w każdym obszarze',
  description: 'Obejmuje wszystko: plany treningowe, taktykę, ocenę zawodnika, zarządzanie grupą i komunikację z rodzicami.'
}, {
  icon: Infinity,
  title: 'Twoje na zawsze',
  description: 'Jednorazowa płatność. Brak opłat miesięcznych. Używaj kiedy chcesz na każdym urządzeniu.'
}];
export function WhyDifferent() {
  return <section className="w-full bg-cream-alt py-12 md:py-20 px-4 md:px-6" data-id="element-332">
      <div className="max-w-6xl mx-auto" data-id="element-333">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-334">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-navy-primary mb-3 md:mb-4" data-id="element-335">
            Dlaczego ten system jest inny
          </h2>
          <p className="text-base md:text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-336">
            Żadnej teorii. Żadnych miesięcznych subskrypcji. Żadnych drogich
            konsultantów. Tylko gotowe narzędzia.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8" data-id="element-337">
          {principles.map((principle, index) => {
          const Icon = principle.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.15
          }} whileHover={{
            y: -5
          }} className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-gold-accent/20 flex flex-col h-full" data-id="element-338">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-gold-accent/10 rounded-xl flex items-center justify-center mb-4" data-id="element-339">
                  <Icon className="w-6 h-6 md:w-7 md:h-7 text-gold-accent" data-id="element-340" />
                </div>
                <h3 className="text-lg md:text-xl font-display font-bold text-navy-primary mb-2 md:mb-3" data-id="element-341">
                  {principle.title}
                </h3>
                <p className="text-sm md:text-base text-gray-700 leading-relaxed flex-grow" data-id="element-342">
                  {principle.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}